var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "googleplus_svg__a",
    cx: 24,
    cy: 24,
    r: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#googleplus_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.5,
    fill: "#DFE3EB",
    xlinkHref: "#googleplus_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 24c-.2-4 3.5-8 7.7-8 2.2-.2 4.3.7 6 2l-2.2 2c-1.4-.8-3-1.4-4.8-.8-2.7.7-4.3 3.8-3.3 6.4.8 2.7 4.2 4.2 6.8 3 1.3-.4 2.2-1.6 2.6-3h-4.6V23H27c0 2-.2 4.5-1.7 6.3-2 2.5-5.8 3.3-8.8 2.3-3.2-1-5.6-4.3-5.5-7.6zm20.7-4h2.6v2.7H37v2.6h-2.7V28h-2.6v-2.7H29v-2.6h2.7V20z",
    fill: "#DC4E41",
    fillRule: "nonzero"
  }))));
}
export default "data:image/svg+xml,%3csvg width='48' height='48' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3ctitle%3e58E2FEAD-906A-4623-810D-CF2050C6F690%3c/title%3e%3cdefs%3e%3ccircle id='a' cx='24' cy='24' r='24'/%3e%3c/defs%3e%3cg fill='none' fill-rule='evenodd'%3e%3cg%3e%3cuse fill='white' xlink:href='%23a'/%3e%3cuse fill-opacity='.5' fill='%23DFE3EB' xlink:href='%23a'/%3e%3c/g%3e%3cpath d='M11 24c-.2-4 3.5-8 7.7-8 2.2-.2 4.3.7 6 2l-2.2 2c-1.4-.8-3-1.4-4.8-.8-2.7.7-4.3 3.8-3.3 6.4.8 2.7 4.2 4.2 6.8 3 1.3-.4 2.2-1.6 2.6-3h-4.6V23H27c0 2-.2 4.5-1.7 6.3-2 2.5-5.8 3.3-8.8 2.3-3.2-1-5.6-4.3-5.5-7.6zM31.7 20h2.6v2.7H37v2.6h-2.7V28h-2.6v-2.7H29v-2.6h2.7V20z' fill='%23DC4E41' fill-rule='nonzero'/%3e%3c/g%3e%3c/svg%3e";
export { SvgGoogleplus as ReactComponent };